import type { ReactNode } from 'react';
import MyTitleBackgroundImage from '@/assets/images/backgrounds/my-title.png?format=webp&w=600&url';
import cn from '@/utils/merge-class-names';
import { AvatarWithStatus } from '../common/avatar-with-status';

type UserHeroProps = {
  headImg?: string;
  nickname?: string;
  sign?: string;
  addOn?: ReactNode;
  className?: string;
};

export default function UserHero({ headImg, nickname = '', sign, addOn, className }: UserHeroProps) {
  return (
    <div
      style={{
        backgroundImage: `url(${MyTitleBackgroundImage})`,
      }}
      className={cn('bg-cover bg-no-repeat bg-center relative w-full desktop:rounded')}>
      <div className='absolute inset-0 pointer-events-none bg-primary mix-blend-color desktop:rounded' />
      <div className={cn('flex items-center justify-between pt-14 pb-2 px-4 z-20 desktop:py-0', className)}>
        <div className='px-2'>
          <AvatarWithStatus
            imageUrl={headImg}
            className='size-20 desktop:size-18 basis-16 desktop:mt-0 shadow flex-1'
            size={[64, 64]}
          />

          <div className='flex flex-col basis-16 mb-1 justify-center flex-1 items-center gap-2 desktop:gap-0 text-white'>
            <h2 className='font-bold desktop:text-body1'>{nickname}</h2>
          </div>
        </div>

        <div>{addOn}</div>
      </div>
    </div>
  );
}
